import { useMemo } from "react";
import MenuLink from "@core/components/link/MenuLink";
import { useCnbConfig } from "@core/hooks/useCnbConfig";
import { cn } from "@core/utils/domUtil";

export default function LnbMobile() {
  const { activeIndex, menuDepthMap } = useCnbConfig() ?? {};
  const depth3 = useMemo(() => menuDepthMap?.depth3, [menuDepthMap]);

  return (
    depth3 && (
      <div className="mobile-w-full padding-side sticky top-[53px] right-0 left-0 z-50 bg-white py-[10px]">
        <ul className="flex w-full items-center gap-[6px]">
          {depth3?.map(
            (item, idx) =>
              item?.url &&
              item?.name && (
                <li key={item?.name}>
                  <MenuLink url={item?.url} name={item?.name} className={cn("text-md inline-flex h-[36px] items-center justify-center rounded-full border border-gray-200 px-[12px] text-gray-800", idx === activeIndex?.[2] && "border-point-600 text-point-600")} />
                </li>
              ),
          )}
        </ul>
      </div>
    )
  );
}
